import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class DummyRouteService {
  constants: Constants = new Constants();

  httpCustomOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json'
    })
  };

  constructor(private readonly http: HttpClient) { }
  getDetails(): Observable<any> {
    return this.http
      .get(this.constants.getApiBasePath() + `/api/v1/dummyroutes`, this.httpCustomOptions)
      .pipe(
        tap(_ => this.log('data success')),
        catchError(this.handleError<any>('data fails'))
      );
  }

  deleteDummyRoute(arrData: any): Observable<any> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.http
			.delete(this.constants.getApiBasePath() + `/api/v1/dummyroutes/deleteroute/${arrData.dummyRouteID}`, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log('data delete success')),
				catchError(this.handleError<any>('data delete failed'))
			);
	}

  addDummyRoute(arrData: any): Observable<any> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.http
			.post(this.constants.getApiBasePath() + '/api/v1/dummyroutes/addroute', arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log('data inserted success')),
				catchError(this.handleError<any>('data insert failed'))
			);
	}

  private handleError<T>(_operation, result?: T) {
    return (error: any): Observable<T> => {
      console.info(error); // log to console instead
      return of(result as T);
    };
  }

  /** Log a message */
  private log(message: string) {
    console.info('Message: ' + message);
  }
}
